<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite blagajno:
    </h2>

    <DeviceForm
      @save="save"
      @cancel="cancel"
      :device="device"
    />

    <h2>
      Glava računa
    </h2>
    <v-row>
      <v-col cols="12" md="6" offset-md="3">
        <div class="red--text text--lighten-1" v-if="invoiceHeaderTextFromBusinessUnit && originalInvoiceHeaderText">
          Vsebina je podedovana iz nastavitev poslovne enote
        </div>
        <InvoiceTextForm
          v-model="invoiceHeaderText"
          :canReset="true"
          @reset="resetInvoiceHeader"
          @save="saveInvoiceHeader"
        />
      </v-col>
    </v-row>

    <h2>
      Noga računa
    </h2>
    <v-row>
      <v-col cols="12" md="6" offset-md="3">
        <div class="red--text text--lighten-1" v-if="invoiceFooterTextFromBusinessUnit && originalInvoiceFooterText">
          Vsebina je podedovana iz nastavitev poslovne enote
        </div>
        <InvoiceTextForm
          v-model="invoiceFooterText"
          :canReset="true"
          @reset="resetInvoiceFooter"
          @save="saveInvoiceFooter"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DeviceForm from '@/components/DeviceForm'
import InvoiceTextForm from '@/components/InvoiceTextForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    DeviceForm,
    InvoiceTextForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    childCompanyId: {
      required: true,
      type: Number
    },
    businessUnitId: {
      required: true,
      type: Number
    },
    deviceId: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      invoiceHeaderText: '',
      invoiceFooterText: '',
      originalInvoiceHeaderText: '',
      originalInvoiceFooterText: '',
      invoiceHeaderTextFromBusinessUnit: false,
      invoiceFooterTextFromBusinessUnit: false
    }
  },
  computed: {
    device () {
      return this.$store.state.clientsDevices.items[this.deviceId]
    },
    premiseTypes () {
      return objectToArray(this.$store.state.premiseTypes.items)
    }
  },
  methods: {
    ...mapActions('clientsDevices', ['loadItem', 'saveItem']),
    ...mapActions('clientsDevices', {
      loadInvoiceHeader: 'getHeader',
      loadInvoiceFooter: 'getFooter',
      setInvoiceHeader: 'setHeader',
      setInvoiceFooter: 'setFooter'
    }),
    save ({ data }) {
      this.saveItem({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, item: { ...data, id: this.deviceId } })
        .then(item => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          this.$router.push({ name: 'ClientsBusinessUnitsDevices', params: { childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId } })
        })
    },
    saveInvoiceHeader () {
      this.setInvoiceHeader({
        childCompanyId: this.childCompanyId,
        businessUnitId: this.businessUnitId,
        electronicDeviceId: this.deviceId,
        header: this.invoiceHeaderText
      })
        .then(response => {
          // this.$notify({ type: 'success', text: 'Podatki so bili uspešno shranjeni' })
          this.loadFooterAndHeader()
        })
        .catch(anErr => {
          this.$notify({ type: 'error', text: 'Prišlo je do napake pri shranjevanju podatkov' })
        })
    },
    saveInvoiceFooter () {
      this.setInvoiceFooter({
        childCompanyId: this.childCompanyId,
        businessUnitId: this.businessUnitId,
        electronicDeviceId: this.deviceId,
        footer: this.invoiceFooterText
      })
        .then(response => {
          // this.$notify({ type: 'success', text: 'Podatki so bili uspešno shranjeni' })
          this.loadFooterAndHeader()
        })
        .catch(anErr => {
          this.$notify({ type: 'error', text: 'Prišlo je do napake pri shranjevanju podatkov' })
        })
    },
    resetInvoiceHeader () {
      this.invoiceHeaderText = null
      this.saveInvoiceHeader()
    },
    resetInvoiceFooter () {
      this.invoiceFooterText = null
      this.saveInvoiceFooter()
    },
    cancel () {
      this.$router.push({ name: 'ClientsBusinessUnitsDevices', params: { childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId } })
    },
    loadFooterAndHeader () {
      return new Promise((resolve, reject) => {
        Promise.all([
          this.loadInvoiceHeader({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, electronicDeviceId: this.deviceId }),
          this.loadInvoiceFooter({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, electronicDeviceId: this.deviceId })
        ])
          .then(items => {
            this.setLocalInvoiceHeader(items[0])
            this.setLocalInvoiceFooter(items[1])
            resolve()
          })
          .catch(error => reject(error))
      })
    },
    setLocalInvoiceHeader (header) {
      this.originalInvoiceHeaderText = header.data
      this.invoiceHeaderText = header.data !== null ? header.data : ''
      this.invoiceHeaderTextFromBusinessUnit = header.from_business_unit
    },
    setLocalInvoiceFooter (footer) {
      this.originalInvoiceFooterText = footer.data
      this.invoiceFooterText = footer.data !== null ? footer.data : ''
      this.invoiceFooterTextFromBusinessUnit = footer.from_business_unit
    }
  },
  created () {
    this.loadItem({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, deviceId: this.deviceId })
      .then(items => {
        this.loadFooterAndHeader()
          .then(response => {
            this.asyncDataStatus_fetched()
          })
          .catch(anErr => {
            this.$notify({ type: 'error', text: 'Prišlo je do napake pri nalaganju podatkov' })
          })
      })
      .catch(anErr => {
        this.$notify({ type: 'error', text: 'Prišlo je do napake pri nalaganju podatkov' })
      })
  }
}
</script>
